import { ISEOTags } from '../components/SEO/SEOTableTags/SEOTableTagsRow/SEOTableTagsRow';

export const getSortedSeoTags = (tags: ISEOTags[]) =>
  tags.sort((a, b) => b.id - a.id);
